module.exports = __webpack_public_path__ + "img/paypal2.4af682e6.png";